import { StyleSheet, css } from "aphrodite";
import { RectShape } from "react-placeholder/lib/placeholders";

import { COLORS } from "~/config/themes";

const BreadcrumbPlaceholder = (props) => {
  return (
    <div
      className={"show-loading-animation " + css(styles.breadcrumbContainer)}
    >
      <RectShape className={css(styles.placeholderText, styles.mediumLine)} />
      <span className={css(styles.separator)}>
        <svg
          class="flex-shrink-0 h-5 w-5 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillrule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            cliprule="evenodd"
          ></path>
        </svg>
      </span>
      <RectShape className={css(styles.placeholderText, styles.longLine)} />
      <span className={css(styles.separator)}>
        <svg
          class="flex-shrink-0 h-5 w-5 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillrule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            cliprule="evenodd"
          ></path>
        </svg>
      </span>
      <RectShape className={css(styles.placeholderText, styles.mediumLine)} />
    </div>
  );
};

const styles = StyleSheet.create({
  placeholderText: {
    width: "100%",
    height: 18,
    background: COLORS.BLACK(0.1),
    margin: 0,
  },
  shortLine: {
    width: "30%",
  },
  mediumLine: {
    width: 75,
  },
  longLine: {
    width: 125,
  },
  breadcrumbContainer: {
    display: "flex",
  },
  separator: {
    color: COLORS.BLACK(0.7),
    margin: "0 20px",
  },
});

export default BreadcrumbPlaceholder;
